'use client';

import { useState, useEffect } from 'react';
import { fetchHomeData } from '../lib/data';
import { useLanguage } from '../contexts/LanguageContext';

export function useHomeData() {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    const loadData = async () => {
      if (!language) return;
      
      setLoading(true);
      try {
        const data = await fetchHomeData({ lang: language });
        setHomeData(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching home data:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [language]);

  return { homeData, loading, error };
}
